import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Grid, Card, CardContent, Typography, Button, CardMedia, Box, } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VolumeMuteIcon from "@mui/icons-material/VolumeMute";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const Step3 = () => {
    

    return (
         
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundImage: `url(image/background.jpg)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    p: 2,
                }}
            >
                   <Grid item xs={4} sx={{ position: "absolute" , top:"10px", width:"90%" }}>
                        <Grid container justifyContent="space-between" alignItems="center">
                            {/* Left Image */}
                            <Grid item>
                                <img src="/image/Actify365.png" alt="Logo" width="200px" />
                            </Grid>

                            {/* Right Image */}
                            <Grid item>
                                <img src="/image/Actify365.png" alt="School Logo" width="200px" />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                         
                        flexDirection: "column",
                        p: 2,
                    }}>


 
                    </Box>

                
            </Box>


        
    );
};

export default Step3;
